import React, { Fragment } from "react";
import {
  Page,
  Document,
  Image,
  StyleSheet,
  Text,
  Font,
  View,
} from "@react-pdf/renderer";

import logo from "assets/images/logo.png";

import allfont from "../../../../assets/fonts/ZCOOL_XiaoWei/ZCOOLXiaoWei-Regular.ttf";

import default_logo from "assets/images/headerLogo.png";

Font.register({
  family: "ZCOOL XiaoWei",
  src: allfont,
});

const borderColor = "#90e5fc";
const styles = StyleSheet.create({
  page: {
    minWidth: "72.1mm",
    maxWidth: "72.1mm",
    padding: 15,
    //fontFamily: "ZCOOL XiaoWei",
  },
  section: {
    color: "black",
    textAlign: "center",
    marginBottom: 2,
  },
  headerTitle: {
    fontSize: 12.5,
    fontWeight: 700,
    marginBottom: 10,
  },
  subtitle: {
    fontSize: 13,
    fontWeight: 700,
    marginBottom: 10,
  },
  tableHeader: {
    flexDirection: "row",
    textAlign: "center",
    fontSize: "10px",
    padding: "10px 0px",
  },
  tableBody: {
    flexDirection: "row",
    textAlign: "center",
    fontSize: "8px",
    marginBottom: 4,
  },
  receipt: {
    textAlign: "center",
    fontSize: 10,
    marginBottom: 10,
  },
  qty: {
    width: "10%",
  },
  description: {
    width: "65%",
  },
  payment: {
    width: "20%",
  },
  subTotal: {
    textAlign: "right",
    fontSize: 10,
    marginBottom: 7,
  },
  memberInfo: {
    textAlign: "left",
    fontSize: 10,
    marginBottom: 4,
  },
  loginInfo: {
    borderTop: "2px dotted",
    borderTopWidth: 1,
    borderTopStyle: "dashed",
    padding: "10px 0px",
  },
  thankYouData: {
    fontSize: 11,
    textAlign: "center",
    fontWeight: 700,
    textTransform: "uppercase",
    fontWeight: "bold",
    paddingTop: 1,
    paddingBottom: 1,
  },

  logo: {
    maxWidth: "100%",
    height: "80px",
  },

  // prepaidContainer
  prepaidContainer: {
    display: "flex",
    flexDirection: "row",
  },
  width60: {
    width: "60%",
  },
  width40: {
    width: "40%",
  },
  titlecontainer: {
    fontSize: 11,
    fontWeight: 500,
    fontWeight: "bold",
    textAlign: "center",
  },
  prepaidBorder: {
    borderTop: 1,
    borderStyle: "dotted",
  },
  desTitle: {
    fontSize: 8,
    textAlign: "center",
    lineHeight: 1.5,
  },
  desBalance: {
    fontSize: 8,
    textAlign: "center",
  },
  marginVertical4: {
    marginVertical: 4,
  },
  footerContainer: {
    paddingTop: 10,
    paddingBottom: 3,
    borderBottomWidth: 1,
    borderBottomStyle: "dashed",
  },

  footerData: {
    textAlign: "center",
    fontSize: 10,
    fontWeight: 600,
    marginBottom: 1,
  },
  thankYou: {
    marginTop: 1,
    borderTopWidth: 1,
    borderTopStyle: "dashed",
    borderBottom: 1,
    borderBottomStyle: "dashed",
    paddingVertical: 1,
  },
});

export class Thermal extends React.Component {
  render() {
    let { accountHeader, responseData, currency } = this.props;
    console.log(responseData, "responseData");
    console.log(accountHeader, "accountHeader");
    let {
      hdr_data = [],
      dtl_data = [],
      sub_data = {},
      taud_data = [],
      footer = {},
      taud_sub = {},
    } = responseData;
    let { showprepaid, prepaidlst } = footer;
    return (
      <Document file="somefile.pdf">
        <Page size="A4" style={styles.page}>
          <View style={styles.section}>
            <Image
              style={styles.logo}
              src={accountHeader?.logo ? accountHeader?.logo : default_logo}
            />
            <View style={styles.headerText}>
              <Text style={styles.subtitle}>
                {accountHeader?.address
                  ? accountHeader?.address
                  : "211 Holland Ave, Holland Road Shopping Center #0343 Singapore 278969 Apt: 6469 9141 | Whatsapp: 8121 4779"}
              </Text>
            </View>
          </View>
          <Text style={styles.receipt}>
            Reciept: {hdr_data ? hdr_data?.trans : "N/A"}
          </Text>

          <View style={styles.tableHeader} fixed>
            <Text style={styles.qty}>{`Qty`}</Text>
            <Text style={styles.description}>{`Description`}</Text>
            <Text style={styles.payment}>{`Amt`}</Text>
          </View>
          {dtl_data?.length > 0
            ? dtl_data?.map((item, index) => {
                return (
                  <View style={styles.tableBody} key={index}>
                    <Text style={styles.qty}>{item?.dt_qty}</Text>
                    <Text style={styles.description}>{item?.dt_itemdesc}</Text>
                    <Text style={styles.payment}>
                      {currency}&nbsp;{item?.dt_transacamt}
                    </Text>
                  </View>
                );
              })
            : ""}
          <View style={styles.loginInfo}>
            <Text style={styles.subTotal}>
              Sub Total {currency}&nbsp;
              {sub_data?.sub_total}
            </Text>
            <Text style={styles.subTotal}>
              Total {currency}&nbsp;{taud_sub?.grand_tot}
            </Text>
            {taud_data &&
              taud_data?.length > 0 &&
              taud_data?.map((item, index) => {
                return (
                  <Text style={styles.subTotal} key={index}>
                    {item?.pay_type_name} {currency}&nbsp;{item?.pay_amt}
                  </Text>
                );
              })}
          </View>
          <View style={styles.loginInfo}>
            <Text style={styles.memberInfo}>Member Info</Text>
            <Text style={styles.memberInfo}>
              Name: {hdr_data ? hdr_data?.sa_custname : ""}
            </Text>
            <Text style={styles.memberInfo}>
              HP: {hdr_data ? hdr_data?.cust_phone2 : ""}
            </Text>
          </View>

          {showprepaid && prepaidlst && prepaidlst?.length > 0 && (
            <View>
              <View style={styles.prepaidContainer}>
                <View style={styles.width60}>
                  <Text style={styles.titlecontainer}>Program Desc </Text>
                </View>
                <View style={styles.width40}>
                  <Text style={styles.titlecontainer}>Balance</Text>
                </View>
              </View>
              <View style={styles.prepaidBorder} />

              {prepaidlst?.map((item, id) => {
                return (
                  <View
                    key={id}
                    style={[styles.prepaidContainer, styles.marginVertical4]}
                  >
                    <View style={styles.width60}>
                      <Text style={styles.desTitle}>{item?.pp_desc} </Text>
                    </View>
                    <View style={styles.width40}>
                      <Text style={styles.desBalance}>{item?.remain}</Text>
                    </View>
                  </View>
                );
              })}
            </View>
          )}

          {/* <View style={styles.loginInfo}>
            <Text style={styles.memberInfo}>
              Login ID: {hdr_data ? hdr_data.id : ""}
            </Text>
            <Text style={styles.memberInfo}>
              Therapist: {hdr_data ? hdr_data.issued : ""}
            </Text>
            <Text style={styles.memberInfo}>
              Date: {hdr_data ? hdr_data.sa_date : ""}{" "}
              {hdr_data ? hdr_data.sa_time : ""}
            </Text>
          </View> */}

          <View style={styles.thankYou}>
            <Text style={styles.thankYouData}>Thank You, See You Again!</Text>
          </View>
          <View style={styles.footerContainer}>
            {footer?.trans_promo1 && (
              <Text style={styles.footerData}>{footer?.trans_promo1}</Text>
            )}
            {footer?.trans_promo2 && (
              <Text style={styles.footerData}>{footer?.trans_promo2}</Text>
            )}
          </View>
        </Page>
      </Document>
    );
  }
}
export default Thermal;
